// MIX sets all the MIX_ environment variables up as strings, which causes
// issues because our booleans are then always true ("false" == true). So we
// convert them. It may seem wasteful, but it really does eliminate some weird
// looking logic (if(enable_video != "0") for instance, instead of just
// if(enable_video))

// Take a copy of process.env
// NOTE - This no longer works in Laravel Mix v4 (it used to in v2)
//window.environment_settings = JSON.parse(JSON.stringify(process.env));
window.environment_settings = {};

// To add new variables you need to run the bin/process_mix_variables.sh script
// and paste the output in below. I realise how shit that is, but since Mix v4
// the old method (above) doesn't work any more. Boo hoo face.
window.environment_settings["MIX_APP_VERSION"] = process.env.MIX_APP_VERSION
window.environment_settings["MIX_CACHE_VERSION"] = process.env.MIX_CACHE_VERSION
window.environment_settings["MIX_CACHE_MAX"] = process.env.MIX_CACHE_MAX
window.environment_settings["MIX_ENABLE_CACHE"] = process.env.MIX_ENABLE_CACHE
window.environment_settings["MIX_CACHE_ATTACHMENTS"] = process.env.MIX_CACHE_ATTACHMENTS
window.environment_settings["MIX_PUSHER_APP_KEY"] = process.env.MIX_PUSHER_APP_KEY
window.environment_settings["MIX_PUSHER_APP_CLUSTER"] = process.env.MIX_PUSHER_APP_CLUSTER
window.environment_settings["MIX_LOCAL_SOCKETIO_SERVER"] = process.env.MIX_LOCAL_SOCKETIO_SERVER
window.environment_settings["MIX_SOCKETIO_PORT"] = process.env.MIX_SOCKETIO_PORT
window.environment_settings["MIX_LOCAL_SOCKETIO_PORT"] = process.env.MIX_LOCAL_SOCKETIO_PORT
window.environment_settings["MIX_LOCAL_SOCKETIO_PROTOCOL"] = process.env.MIX_LOCAL_SOCKETIO_PROTOCOL
window.environment_settings["MIX_PATIENT_SOCKETIO_PORT"] = process.env.MIX_PATIENT_SOCKETIO_PORT
window.environment_settings["MIX_SOCKETIO_PREFIX"] = process.env.MIX_SOCKETIO_PREFIX
window.environment_settings["MIX_HANDLE_ERRORS"] = process.env.MIX_HANDLE_ERRORS
window.environment_settings["MIX_ENABLE_VIDEO"] = process.env.MIX_ENABLE_VIDEO
window.environment_settings["MIX_ENABLE_BROWSEALOUD"] = process.env.MIX_ENABLE_BROWSEALOUD
window.environment_settings["MIX_WAIT_TIME_MEASURE"] = process.env.MIX_WAIT_TIME_MEASURE
window.environment_settings["MIX_ENABLE_FUSION"] = process.env.MIX_ENABLE_FUSION
window.environment_settings["MIX_VAPID_PUBLIC_KEY"] = process.env.MIX_VAPID_PUBLIC_KEY
window.environment_settings["MIX_ENABLE_APPOINTMENTS"] = process.env.MIX_ENABLE_APPOINTMENTS
window.environment_settings["MIX_ENABLE_LANGUAGE_SELECTION"] = process.env.MIX_ENABLE_LANGUAGE_SELECTION
window.environment_settings["MIX_LIVE_TABLEAU_SERVER"] = process.env.MIX_LIVE_TABLEAU_SERVER
window.environment_settings["MIX_HSCN_TABLEAU_SERVER"] = process.env.MIX_HSCN_TABLEAU_SERVER
window.environment_settings["MIX_AWS_TABLEAU_SERVER"] = process.env.MIX_AWS_TABLEAU_SERVER
window.environment_settings["MIX_TABLEAU_ENVIRONMENT"] = process.env.MIX_TABLEAU_ENVIRONMENT
window.environment_settings["MIX_ENABLE_ARCHIVE"] = process.env.MIX_ENABLE_ARCHIVE
window.environment_settings["MIX_TABLEAU_VERSION"] = process.env.MIX_TABLEAU_VERSION




for(var index in window.environment_settings) {
    // Convert strings 'true' and 'false' to booleans.
    if(window.environment_settings[index] === 'true' || window.environment_settings[index] === 'false') {
        window.environment_settings[index] = window.environment_settings[index] === 'true';
    }

    // Convert numerical strings to numbers (disabled for now as isNaN("")
    // equates to false and parseInt("") returns null, which is just wrong).
    // Also, what do we do with floats? At the end of the day, numbers convert
    // okay with loose types (whereas booleans do not).

    // else if(!isNaN(window.environment_settings[index])) {
    //     window.environment_settings[index] = parseInt(window.environment_settings[index]);
    // }
}
